export enum RegistrationFormType {
  SINGLE = "SINGLE",
  BULK = "BULK"
}
